export interface UserProfileModel {
  name: string;
  google2FAEnabled: boolean;
  email2FAEnabled: boolean;
}
